<template>
  <div class="main-dash">
    <el-row
      :gutter="20"
      type="flex"
      class="row-bg"
      justify="end"
      style="align-items: center;">
      <el-col
        :xs="4"
        :sm="4"
        :md="4"
        :lg="2">
        <h5><strong>AÑOS</strong></h5>
      </el-col>
      <el-col
        :xs="8"
        :sm="6"
        :md="4"
        :lg="3"
        style="margin-bottom: 10px;">
        <el-select v-model="year">
          <el-option
            v-for="(year, index) in years"
            :key="index"
            :label="year.name"
            :value="year.value"/>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <dashboard-cards
          :year="year"
          :profile="profile"/>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <dashboard-chart-line
          :year="year"
          :profile="profile"
          @addCampaign="toggleCampaignPanel"/>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- <dashboard-chart-seller
          v-if="profile.role === 'vendedor_dealer'"/> -->
        <dashboard-chart-admin :year="year"/>
      </el-col>
    </el-row>
    <campaign-create
      v-if="showCampaignPanel"
      @closeCampaign="closeCampaign"/>
  </div>
</template>

<script>
import DashboardCards from '@/modules/dashboard/dashboard-cards'
import DashboardChartLine from '@/modules/dashboard/dashboard-chart-line'
import DashboardChartSeller from '@/modules/dashboard/dashboard-chart-seller'
import DashboardChartAdmin from '@/modules/dashboard/dashboard-chart-admin'
import CampaignCreate from '@/views/app/campaigns/campaign-create-view'
import moment from 'moment'

export default {
  name: 'DashboardView',
  components: {
    DashboardCards,
    DashboardChartLine,
    DashboardChartSeller,
    DashboardChartAdmin,
    CampaignCreate
  },
  data () {
    return {
      showCampaignPanel: false,
      year: moment().format('YYYY'),
      years: [
        {
          label: moment().subtract(1, 'year').format('YYYY'),
          value: moment().subtract(1, 'year').format('YYYY')
        },
        {
          label: moment().format('YYYY'),
          value: moment().format('YYYY')
        },
        {
          label: moment().add(1, 'year').format('YYYY'),
          value: moment().add(1, 'year').format('YYYY')
        }
      ]
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    closeCampaign (value) {
      if (value) {
        this.showCampaignPanel = false
        this.$store.dispatch('app/toggleCampaignPanel')
      }
    },
    toggleCampaignPanel () {
      this.showCampaignPanel = true
      this.$store.dispatch('app/toggleCampaignPanel')
    }
  }
}
</script>

<style scoped lang="scss">
  .main-dash{
    padding: 30px;
    height: calc(100% - 125px);
    overflow: auto;
    h5 {
      margin: 0;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/dashboard/dashboard-view.vue